import React, { useState } from 'react'
import '../../Assets/Css/LogIn.scss'
import emailIcon from '../../Assets/Images/Login-Page/email-icon.png'
import showEye from '../../Assets/Images/Login-Page/showeye.png'
import hideEye from '../../Assets/Images/Login-Page/hideeye.png'
import facebook from '../../Assets/Images/Login-Page/facebook.png'
import google from '../../Assets/Images/Login-Page/google.png'
import apple from '../../Assets/Images/Login-Page/apple.png'
import logo from '../../Assets/Images/Login-Page/logo.svg'
import imageFront from '../../Assets/Images/Login-Page/imageFront.png'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import * as authActions from '../../Services/Authentication/action'
import { loginSchema } from '../../Validations/loginValidation'
import { useFormik } from 'formik'

const LogIn = (props) => {
    let navigate = useNavigate();

    const login = async (email, password) => {
        const user = await props.handleLogin(email, password)
        navigate('/dashboard')
    }

    const onSubmit = async (values, actions) => {
        await login(values.email, values.password)
        actions.resetForm()
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        handleBlur,
        isSubmitting,
        touched,
        setFieldValue
     } = useFormik({
            initialValues: {
                email: '',
                password: ''
            },
            validationSchema: loginSchema,
            onSubmit
        })

    const [show, setShow] = useState(true);

    return (
        <div className='main-page'>
            <div className="frontImg">
                <img src={imageFront} alt="front-animation" className='banner-image' />
            </div>
            <div className="box">
                <div className="left-image">
                    <div className="left-round"></div>
                </div>
                <div className="right-image">
                    <div className="right-round"></div>
                </div>
            </div>
            <div className="container custom-grid">
                <div className="row custom-grid-1">
                    <div className="col-lg-8 col-md-12 d-flex mt-0">
                        <div className='left'>
                            <h5>Encourage innovation with</h5>
                            <img src={logo} alt="logo" className='logo mt-2' />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 d-flex">
                        <div className="right">
                            <form className='form-page' onSubmit={touched && handleSubmit} >
                                <div className='username'>
                                    <input className={errors.email && touched.email ? 'input-error' : null} type='text' name='email' value={values.email} onChange={handleChange} onBlur={handleBlur} placeholder='Enter Email' />
                                    <label htmlFor="text"><button className='label-btn' onClick={(e) => {e.preventDefault(); setFieldValue('email', '')}}><img src={emailIcon} alt="email" /></button></label>
                                </div>
                                {errors.email && touched.email && <p className='error-text' >{errors.email}</p>}
                                <div className='password'>
                                    <input className={errors.password && touched.password ? 'input-error' : null} type={show ? 'password' : 'text'} name="password" value={values.password} onChange={handleChange} onBlur={handleBlur} placeholder='Password' />
                                    <label htmlFor="text"><button className='label-btn'><img src={show ? showEye : hideEye} alt="password-show"
                                        onClick={(e) => { e.preventDefault(); setShow(!show) }} /></button></label>
                                </div>
                                {errors.password && touched.password && <p className='error-text' >{errors.password}</p>}
                                <div className="reset-password">
                                    <a href="/">Recovery Password?</a>
                                </div>
                                <div className='submit-btn'>
                                    <button type='submit' className={isSubmitting ? 'submitting' : ''} disabled={isSubmitting} >Sign in</button>
                                </div>
                            </form>
                            <div className='continue'>
                                <div className="text-divider">
                                    <p>Or Continue With</p>
                                </div>
                                <div className="icon">
                                    <div className='icon-google'>
                                        <img src={google} alt='google' />
                                    </div>
                                    <div className='icon-apple'>
                                        <img src={apple} alt="apple" />
                                    </div>
                                    <div className='icon-facebook'>
                                        <img src={facebook} alt="facebook" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.authenticationReducer.user,
        success: state.authenticationReducer.success,
        loading: state.authenticationReducer.loading,
        error: state.authenticationReducer.error
    }
}

const mapDispatchToProps = {
    handleLogin: authActions.handleLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(LogIn)
